import { render, staticRenderFns } from "./thinktankItem.vue?vue&type=template&id=902763aa&scoped=true"
import script from "./thinktankItem.vue?vue&type=script&lang=js"
export * from "./thinktankItem.vue?vue&type=script&lang=js"
import style0 from "./thinktankItem.vue?vue&type=style&index=0&id=902763aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902763aa",
  null
  
)

export default component.exports